var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { Text, TEXT_SIZE, TEXT_VIEW, TEXT_WHITE_SPACE } from "../Text";
import { createUIElement, SIZE_XS } from "../helpers";
import { FIELD_LAYOUT_HELP_TEXT_VIEW } from "./types";
var LABEL_DESCRIPTION_OFFSET = "28px";
var labelDescriptionCSS = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding-left: ", ";\n    margin-top: 0;\n"], ["\n    padding-left: ", ";\n    margin-top: 0;\n"])), LABEL_DESCRIPTION_OFFSET);
var normalDescriptionCSS = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-top: ", ";\n"], ["\n    margin-top: ", ";\n"])), SIZE_XS);
var StyledText = styled(Text)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    margin-bottom: ", ";\n\n    ", "\n\n    ", "\n"], ["\n    display: flex;\n    margin-bottom: ", ";\n\n    ",
    "\n\n    ",
    "\n"])), SIZE_XS, function (_a) {
    var helpTextView = _a.helpTextView;
    return helpTextView === FIELD_LAYOUT_HELP_TEXT_VIEW.normal && normalDescriptionCSS;
}, function (_a) {
    var helpTextView = _a.helpTextView;
    return helpTextView === FIELD_LAYOUT_HELP_TEXT_VIEW.labelDescription && labelDescriptionCSS;
});
export var HelpText = createUIElement('FieldHelpText', function (_a, ref) {
    var className = _a.className, children = _a.children, error = _a.error, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "children", "error", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (React.createElement(StyledText, __assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: "vm-FieldHelpText " + className, whitespace: TEXT_WHITE_SPACE.normal, size: TEXT_SIZE.s, view: error ? TEXT_VIEW.error : TEXT_VIEW.light, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }), children));
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=HelpText.js.map